import { render, staticRenderFns } from "./IrrRequestListComponent.vue?vue&type=template&id=b45d6dc4"
import script from "./IrrRequestListComponent.vue?vue&type=script&lang=js"
export * from "./IrrRequestListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports